import React from 'react'
import { signInWithGoogle, signOut } from '../firebase/firebase-utils';
import { Container, Navbar, Nav, Button, Row, Col, Image } from 'react-bootstrap'
import { FaBars } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import './styles.scss';
import Architecture from '../assets/ourwork/Architecture.png'
import Techseminal from '../assets/ourwork/Techseminal.png'
import Greenland from '../assets/ourwork/greenland.png'

function Ourwork(props) {
    return (
        <div className='Ourwork'>
            <Navbar className='Nav' collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand className="NavLogo" as={Link} to="/"><span>T</span>ech<span>S</span>eminal</Navbar.Brand>
                    <Navbar.Toggle className="toogle-btn" aria-controls="responsive-navbar-nav">
                        <FaBars />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link as={Link} className="navLinks" to="/freelance">Home</Nav.Link>
                            <Nav.Link className="navLinks" as={Link} to="/freelance#categories" >Categories</Nav.Link>
                            {props.user ? <Nav.Link as={Link} className="navLinks" to="/freelance/myOrders">My Orders</Nav.Link> : null}
                            {
                                !props.user ?
                                    <Button onClick={signInWithGoogle} className="actionBtn">Sign In</Button>
                                    :
                                    <Button onClick={() => { signOut(); window.location.reload() }} className="actionBtn">Sign Out</Button>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <header>
                <div className="banner">
                    <Container>
                        <Row className="align-items-center">
                            <Col sm={12} md={4} lg={4}>
                                <p style={{ color: 'rgba(0,0,0,0.5)', fontFamily: 'Viga', textTransform: 'uppercase', letterSpacing: '7px', fontSize: '14px' }}>we got this</p>
                                <p className="heading">
                                    Our work. Done <span style={{ textDecoration: 'underline', textDecorationColor: '#057BD0' }}>right</span>
                                </p>
                            </Col>
                            <Col sm={12} md={8} lg={8} className="descrip">
                                Inorder to make your websites look beautiful and professional we are using latest technologies out there in the market.
                                The framework React Js which is backed by facebook and used by many developers in general. So, we choose this framework to build
                                your applications. our team will get into each and every detail that matters to you and get you work done with in no time.
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <h2 style={{ fontFamily: "Kanit", fontWeight: '600' }}>Projects</h2>
                    <br />
                    <div className="products">
                        <Image src={Techseminal} className="image" />
                        <Image src='https://cdn.dribbble.com/users/1615584/screenshots/14267126/media/f620f6d53c73eea457078d41bdd16cc1.jpg' className="image" />
                        <Image src='https://cdn.dribbble.com/users/1720295/screenshots/14995572/media/108448450322828d68fdbf279223f7c6.png?compress=1&resize=1000x750' className="image" />
                    </div>
                </Container>
            </header>
            <div style={{ margin: '20px 0' }}>
                <center>
                    <p style={{ fontWeight: '600' }}>Copyright © 2021 Designed and Developed by TeamTechSeminal</p>
                </center>
            </div>
        </div>
    )
}

export default Ourwork
